const Spinner = () => {
    return (
        <div className="d-flex justify-content-center align-items-center">
            <div className="spinner-border"></div>
        </div>
    )
}

export default Spinner;